import { CdkScrollable } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';

import { TranslateModule } from '@ngx-translate/core';

export const MODULES = [
  CommonModule,
  MatCheckboxModule,
  MatDialogModule,
  MatButtonModule,
  TranslateModule,
];
export const DIRECTIVES = [CdkScrollable];

@Component({
  selector: 'app-dialog-provacy-policy-user',
  templateUrl: 'dialog-privacy-policy-user.component.html',
  imports: [...MODULES, ...DIRECTIVES],
})
export class DialogPrivacyPolicyUserComponent {
  public data = inject(MAT_DIALOG_DATA);
}
